import { ApplicationState } from '../..';
import { createDeleteDocumentRequest, DeleteDocumentRequest } from '../shared/model';

export const rimIds = (state: ApplicationState) => state.details.detailsRim.rimsTotal.map(rim => rim.rimData.rimHeaderId);
export const svsIds = (state: ApplicationState) => state.details.detailsSvs.svsItems.map(svs => svs.id);
export const selectedRimIds = (state: ApplicationState) => state.details.detailsOverview.rimSelectedIds;
export const selectedSvsIds = (state: ApplicationState) => state.details.detailsOverview.svsSelectedIds;
export const nonValidRimIds = (state: ApplicationState) => state.details.detailsOverview.rimNonValidIds;
export const nonValidSvsIds = (state: ApplicationState) => state.details.detailsOverview.svsNonValidIds;
export const svsNonValidBusinessList = (state: ApplicationState) => state.details.detailsOverview.svsNonValidBusinessList;
export const rimNonValidBusinessList = (state: ApplicationState) => state.details.detailsOverview.rimNonValidBusinessList;
export const askedAmount = (state: ApplicationState) => state.details.detailsOverview.askedAmount;

export const selectedImageIds = (state: ApplicationState) =>
    state.details.detailsImages.images.filter(doc => state.details.detailsOverview.documentSelectedIds.includes(doc.id)).map(x => x.id);

export const selectedOtherAttachmentIds = (state: ApplicationState) =>
    state.details.detailsOtherAttachments.otherAttachments.filter(doc => state.details.detailsOverview.documentSelectedIds.includes(doc.id)).map(x => x.id);

export const selectedFreeTextIds = (state: ApplicationState) => state.details.detailsOverview.freeTextSelectedIds;
export const selectedReportIds = (state: ApplicationState) => state.details.detailsOverview.reportSelectedIds;
export const selectedHonoraryNoteIds = (state: ApplicationState) => state.details.detailsOverview.honoraryNoteSelectedIds;

export const selectedDocumentRequestsForDelete = (state: ApplicationState): DeleteDocumentRequest[] => {
    const imagesToDelete = state.details.detailsImages.images.filter(doc => state.details.detailsOverview.documentSelectedIds.includes(doc.id)).map(x => {
        const request = createDeleteDocumentRequest();

        request.id = +x.id;
        request.amazonId = x.amazonId;
        request.thumbAmazonId = x.thumbAmazonId;

        return request;
    });

    const otherAttachmentsToDelete = state.details.detailsOtherAttachments.otherAttachments.filter(doc => state.details.detailsOverview.documentSelectedIds.includes(doc.id)).map(x => {
        const request = createDeleteDocumentRequest();

        request.id = +x.id;
        request.amazonId = x.amazonId;
        // request.thumbAmazonId = x.thumbAmazonId; // re-check this one

        return request;
    });

    return imagesToDelete.concat(otherAttachmentsToDelete);
};

export const selectedFreeTextRequestsForDelete = (state: ApplicationState): DeleteDocumentRequest[] =>
    state.details.detailsCommentOrReport.commentsOrReports.filter(doc => state.details.detailsOverview.freeTextSelectedIds.includes(doc.id)).map(x => {
        const request = createDeleteDocumentRequest();

        request.id = +x.id;
        request.amazonId = x.amazonId;
        // request.thumbAmazonId = x.thumbAmazonId; // re-check this one

        return request;
    });

export const selectedReportRequestsForDelete = (state: ApplicationState): DeleteDocumentRequest[] =>
    state.details.detailsCommentOrReport.commentsOrReports.filter(doc => state.details.detailsOverview.reportSelectedIds.includes(doc.id)).map(x => {
        const request = createDeleteDocumentRequest();

        request.id = +x.id;
        request.amazonId = x.amazonId;
        // request.thumbAmazonId = x.thumbAmazonId; // re-check this one

        return request;
    });

export const selectedCaseCode = (state: ApplicationState): string => state.caseState.selectedCase.caseCode;
export const selectedCaseInstructionId = (state: ApplicationState): number => state.caseState.selectedCase.instructionId;
